import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getDropdowns = async () => {
  try {
    const results = await Promise.allSettled([
      dropdownMapping(
        endpoint.businessArea.getAllActiveV2,
        "businessAreaDispValue",
        "businessAreaDispValue"
      ),
      dropdownMapping(
        endpoint.term.getAllActive,
        "termDispValue",
        "termDispValue"
      ),
      dropdownMapping(
        endpoint.businessArea.getCashierOfficeDetails,
        "businessAreaDispValue",
        "businessAreaDispValue"
      )

    ]);


    const [businessAreas, terms, cashierOffice] = results.map(r =>
      r.status === "fulfilled" ? r.value : []
    );

    return {
      businessAreas,
      terms,
      cashierOffice,
    };
  } catch (e) {
    console.error("getDropdowns failed:", e);
    return {
      businessAreas: [],
      paymentModeType: [],
      terms: [],
      paymentStatus: [],
    };
  }
};

export const fetchOutstandingList = async ({filters,offset,pageSize}) => {
  const url = !filters?.isToBeFollow ? `${endpoint.followOutstanding}?offset=${offset}&pageSize=${pageSize}` : `${endpoint.outstanding.getAllStudentApplications}?offset=${offset}&pageSize=${pageSize}`; 
  return await fetchAllPostPromisedData(url, updateRequest(filters));
}

export const updateRemarksandReminder = async (reqObj) => {
  return await fetchAllPostPromisedData(endpoint.outstanding.reminder, reqObj);
}

export const fetchStudentDetsailsByPsid = async (psid) => {
  return await fetchAllPromisedData(`${endpoint.studentDetails.getStudentPersonalInfo}/${psid}?mask=true`);
}

export const fetchStudentContactDetail = async (psid) => {
  return await fetchAllPromisedData(`${endpoint.studentDetails.getStudentContactDetails}/${psid}`);
}

 export const formatContactResponse = (response) => {
    const fatherEmailDetail = response?.studentEmailDetailDTOList.find(
      (item) => item.communicationType == "Email" && item.contactType == "HOME"
    );
    const motherEmailDetail = response?.studentEmailDetailDTOList.find(
      (item) => item.communicationType == "Email" && item.contactType == "OTHR"
    );
    const fatherPhoneNumberDetail = response?.studentPhoneDetailDTOList.find(
      (item) => (item.communicationType = "Phone" && item.contactType == "HOME")
    );
    const motherMobileNumberDetail = response?.studentPhoneDetailDTOList.find(
      (item) => (item.communicationType = "Phone" && item.contactType == "CELL")
    );
 
     return {fathersEmailId: fatherEmailDetail?.contactValue,
      mothersEmailId: motherEmailDetail?.contactValue,
      fathersMobileNumber: fatherPhoneNumberDetail?.contactValue,
      mothersMobileNumber: motherMobileNumberDetail?.contactValue,
    };
  };